import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import { createPinia } from "pinia";
import CustomSVG from "@/components/custom/CustomSVG.vue";

// 引入所有 SVG
const requireAll = (requireContext: __WebpackModuleApi.RequireContext) =>
  requireContext.keys().forEach(requireContext);
const req = require.context("@/assets/svg", false, /\.svg$/);
requireAll(req);

const app = createApp(App);

// app.use(store);
const pinia = createPinia();
app.use(pinia);

// 全局注册自定义组件
app.component("CustomSVG", CustomSVG);
app.use(router);
app.mount("#app");
